import React from "react";
import PropTypes from "prop-types";
import { isEmpty } from "lodash";
import { AUTH } from "./AuthenticationProvider";

const TENANT_KEY = "tenant";

const getTenantFromStorage = () => {
  return sessionStorage.getItem(TENANT_KEY);
};

const getTenantFromUrl = () => {
  if (
    window.location.pathname === AUTH.CALLBACK ||
    window.location.pathname === AUTH.SILENT_CALLBACK ||
    window.location.pathname === AUTH.SESSION_LOST ||
    window.location.pathname === AUTH.LOGOUT_REDIRECT
  ) {
    return getTenantFromStorage();
  }
  const parsedData = window.location.pathname.split("/");
  if (parsedData && parsedData.length > 2 && !isEmpty(parsedData[1]) && !isEmpty(parsedData[2])) {
    return `${parsedData[1]}_${parsedData[2]}`;
  }
  return null;
};

const getTenantId = () => {
  const tenant = getTenantFromUrl();

  if (!tenant) return null;

  const storeTenant = getTenantFromStorage();

  if (tenant && storeTenant) {
    if (tenant !== storeTenant) {
      saveTenant(tenant);
      sessionStorage.clear();
    }
    return tenant;
  }

  if (tenant && !storeTenant) {
    saveTenant(tenant);
    return tenant;
  }

  if (!tenant && storeTenant) {
    return storeTenant;
  }

  return null;
};

const getTenant = () => {
  const tenantId = getTenantId();
  if (!tenantId) return null;
  const [countryCode, vendorCode] = tenantId.split("_");
  return { countryCode, vendorCode };
};

const getTenantUrlSufix = () => {
  const tenant = getTenant();
  if (!tenant) return null;
  return `/${tenant.countryCode}/${tenant.vendorCode}`;
};

const saveTenant = (tenant) => {
  sessionStorage.setItem(TENANT_KEY, tenant);
};

const TenantProvider = (props) => {
  const { children } = props;
  if (getTenant()) return <>{children}</>;
  return <>Missing country code and/or vendor code from url path.</>;
};

TenantProvider.propTypes = {
  children: PropTypes.object,
};

export { TenantProvider, getTenantId, getTenant, getTenantUrlSufix };
